import { Helmet } from 'react-helmet-async';
import { useEffect, useState } from 'react';
import Pagination from 'react-js-pagination';
import { Card, Stack, Container, TextField, Grid, CircularProgress } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { getDateTime } from '../../utils/getDate';
import { getAllBookings } from '../../redux/actions/HotelBookingActions';
import { clearError } from '../../redux/actions/contactAction';
import { AppWidget } from '../../sections/@dashboard/app';
import Iconify from '../../components/iconify';

export default function UserPage() {
  const [page, setPage] = useState(1);
  const [keyword, setKeyword] = useState('');
  const [paymentFilter, setPaymentFilter] = useState('paid'); // ⭐ NEW FILTER

  const {
    loading,
    bookings,
    totalNonPaidBookings,
    currentPage,
    limit,
    totalPages,
    totalPaidBookings,
    totalBookings,
    totalCancelBookings,
    totalPersons,
    error,
  } = useSelector((state) => state.getBookings);

  const { hotelId } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Load bookings when page changes or filter changes
  useEffect(() => {
    dispatch(getAllBookings(hotelId, page, paymentFilter)); // ⭐ Api updated
  }, [dispatch, page, paymentFilter]);

  useEffect(() => {
    if (error) {
      toast.error(error);
      dispatch(clearError());
    }
  }, [error]);

  console.log('bookings', bookings);

  const columns = [
    { field: 'id', headerName: 'ID', width: 90 },
    { field: 'name', headerName: 'Name', width: 180 },
    { field: 'email', headerName: 'Email', width: 270 },
    { field: 'persons', headerName: 'Package Count', width: 120 },
    { field: 'status', headerName: 'Status', width: 170 },
    { field: 'createAt', headerName: 'Created At', width: 200 },
    {
      field: '',
      headerName: 'Action',
      width: 100,
      renderCell: (params) => (
        <div className="actionBoxe">
          {/* <Link to={`/dashboard/bookingDetails/${params.row?.id_}`} >
            <Iconify icon="akar-icons:eye" />
          </Link> */}
          <Link to={`https://eoai.in/eoai/hotel-booking/${params.row?.id_}`} target="_blank">
            <Iconify icon="akar-icons:eye" />
          </Link>
        </div>
      ),
    },
  ];

  const rows = [];
  bookings?.forEach((item, i) => {
    rows.push({
      id: i + 1,
      id_: item._id,
      name: item.registrationInfo.FullName,
      email: item.registrationInfo.Email,
      status: item.isPaid ? 'Payment successful' : 'Payment Pending',
      persons: item?.packagesInr?.length,
      createAt: getDateTime(item?.createAt),
    });
  });

  // Admin Auth
  const { user } = useSelector((state) => state.users);
  if (user) {
    if (user.role !== 'admin') navigate('/dashboard/app');
  } else {
    navigate('/');
  }

  return (
    <>
      <Helmet>
        <title>Events bookings</title>
      </Helmet>

      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <div className="totalComponents">
            <Grid item xs={12} sm={6} md={6}>
              <AppWidget title="Total Bookings" total={totalBookings} icon={'ph:users-fill'} />
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <AppWidget title="Total Seats" total={totalPersons} icon={'ph:users-fill'} />
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <AppWidget title="Paid Bookings" total={totalPaidBookings} color="info" icon={'ph:users-fill'} />
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <AppWidget title="Non Paid Bookings" total={totalNonPaidBookings} color="info" icon={'ph:users-fill'} />
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <AppWidget title="Bookings Canceled" total={totalCancelBookings} color="info" icon={'ph:users-fill'} />
            </Grid>
          </div>
        </Stack>

        <Card>
          <div className="tableTop" style={{ display: 'flex', gap: '15px', alignItems: 'center' }}>
            {loading && <CircularProgress color="primary" />}

            {/* Search */}
            <TextField
              type="text"
              onChange={(e) => setKeyword(e.target.value)}
              value={keyword}
              placeholder="Search user"
              size="small"
              label="Search user"
              variant="outlined"
            />

            {/* ⭐ PAYMENT FILTER */}
            <TextField
              select
              size="small"
              label="Filter by Payment"
              SelectProps={{ native: true }}
              value={paymentFilter}
              onChange={(e) => {
                setPage(1);
                setPaymentFilter(e.target.value);
              }}
            >
              <option value="all">All</option>
              <option value="paid">Paid</option>
              <option value="unpaid">Unpaid</option>
            </TextField>
          </div>

          <div style={{ height: 'auto', width: '100%' }}>
            <DataGrid rows={rows} columns={columns} pagination={false} />
          </div>

          {/* ⭐ PAGINATION */}
          <div className="paginationBox">
            <Pagination
              activePage={page}
              itemsCountPerPage={limit}
              totalItemsCount={totalBookings}
              pageRangeDisplayed={5}
              onChange={(e) => setPage(e)}
            />
          </div>
        </Card>
      </Container>
    </>
  );
}
